import AddMessageBoardModal from './modal/add_messageboard';
import ChatMembersModal from './modal/chat_members';
import { fetchClientsCustomerThunk } from '../../redux/thunks/customer';
import { MessageBoardObject } from '../../params/redux/messageboard';
import MessageSection from '../watercooler/message_section';
import { settingSelectedMessageBoard } from '../../redux/slices/messageboard';
import TextFieldSection from '../watercooler/text_field_section';
import { useParams } from 'react-router';
import { Add, Close, Notifications, PeopleAltOutlined } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, IconButton, Menu, MenuItem } from '@mui/material';
import { createMessageBoardConversationThunk, fetchMessageBoardDetailThunk, fetchMessageBoardThunk } from '../../redux/thunks/messageboard';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const MessageBoardComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [chatMemberModal, setChatMemberModal] = useState<boolean>(false);
    const { messageBoards, selectedMessageBoard, conversations, loaders } = useSelector((state: RootState) => state.messageboard);
    const sortedConversations = [...conversations].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    const [dropdownAnchor, setDropdownAnchor] = useState<null | HTMLElement>(null);

    const handleDropdownOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setDropdownAnchor(event.currentTarget);
    };

    const handleDropdownClose = () => {
        setDropdownAnchor(null);
    };

    useEffect(() => {
        const fetchWaterCoolerDetails = async () => {
            try {
                if (selectedMessageBoard) {
                    await dispatch(fetchMessageBoardDetailThunk(selectedMessageBoard.id));
                }
                await dispatch(fetchMessageBoardThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            } catch (e) {
                // Catch errors
            }
        };
        fetchWaterCoolerDetails();
    }, []);

    const createMessage = async (message: string, base64: string | null) => {
        try {
            await dispatch(createMessageBoardConversationThunk({ message, file: base64 || '' })).unwrap();
        } catch (e) {
            // Catch errors
        }
    };

    const fetchAllClientsAndOpenModal = async () => {
        try {
            await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            setShowModal(true);
        } catch (e) {
            // Catch errors
        }
    };
    const handleMessageBoardChange = async (messageboard: MessageBoardObject | 'add') => {
        if (messageboard === 'add') {
            fetchAllClientsAndOpenModal();
            handleDropdownClose();
            return;
        }
        const message_board_id = messageboard.id;
        try {
            await dispatch(fetchMessageBoardDetailThunk(message_board_id)).unwrap();
        } catch (e) {
            // catch errors
        } finally {
            handleDropdownClose();
        }
    };

    const removeMessageBoardHandler = () => {
        dispatch(settingSelectedMessageBoard(null));
    };

    const ViewChatMembersHandler = async () => {
        try {
            await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            setChatMemberModal(true);
        } catch (e) {
            // Catch errors
        }
    };

    return (<Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            {/* Dropdown for selecting a pipeline */}
            <Box mt={1} minWidth="200px" maxWidth="200px">
                <Button onClick={handleDropdownOpen} variant="outlined" fullWidth color="secondary">
                    {selectedMessageBoard ? selectedMessageBoard.name : 'Select Message Board'}
                </Button>

                {/* Dropdown Menu */}
                <Menu
                    anchorEl={dropdownAnchor}
                    open={Boolean(dropdownAnchor)}
                    onClose={handleDropdownClose}
                >
                    {messageBoards.map((messageboard: MessageBoardObject) => (
                        <MenuItem
                            key={messageboard.id}
                            value={messageboard.id}
                            onClick={() => handleMessageBoardChange(messageboard)}
                        >
                            {messageboard.name}
                        </MenuItem>
                    ))}

                    <MenuItem key="add-new" value="add" onClick={() => handleMessageBoardChange('add')}>
                        <Add fontSize="small" /> Add Message Board
                    </MenuItem>
                </Menu>
                {/* <CustomDropdown
                    options={messageBoards.map((messageboard: MessageBoardObject) => ({
                        label: messageboard.name,
                        value: messageboard.id
                    }))}
                    onChange={(e) => handleMessageBoardChange(e)}
                    value={selectedMessageBoard ? selectedMessageBoard.id : ''}
                /> */}
            </Box>
            {selectedMessageBoard
                ? <Box display="flex" alignItems="center" gap={1}>
                    {selectedMessageBoard.is_owner && <IconButton onClick={ViewChatMembersHandler}>
                        <PeopleAltOutlined color="disabled" />
                    </IconButton>}
                    <IconButton>
                        <Notifications color="disabled" />
                    </IconButton>
                    <IconButton onClick={removeMessageBoardHandler}>
                        <Close color="disabled" />
                    </IconButton>
                </Box>
                : <Button variant="contained" onClick={fetchAllClientsAndOpenModal}>Create Message Board</Button>}
        </Box>
        {selectedMessageBoard && (
            <>
                <MessageSection conversations={sortedConversations} loaders={loaders.isLoading} />
                <TextFieldSection createMessageHandler={createMessage} loaders={loaders.isCreating || loaders.isLoading} />
            </>
        )}
        <AddMessageBoardModal open={showModal} onClose={() => setShowModal(false)} />
        <ChatMembersModal open={chatMemberModal} onClose={() => setChatMemberModal(false)} />
    </Box>);
};

export default MessageBoardComponent;